{
  "view": {
    "title": "Varastot",
    "storageUnit": "Varasto",
    "reserve": "Varaa",
    "cancel": "Peruuta",
    "details": "Tiedot",
    "description": "Täällä voit tarkastella varastoja ja varata oman varaston klikkaamalla haluamaasi yksikköä.",
    "noStorageAreas": "Ei saatavilla olevia varastoja",
    "noPermissions": "Ei varausoikeuksia.",
    "acceptTerms": "Hyväksyn {{address}} säännöt ja varaston varausehdot"
  },
  "startOption": {
    "today": "Tänään"
  },
  "legend": {
    "available": "Vapaa",
    "reservedOrInactive": "Varattu",
    "mine": "Oma varaus",
    "mineUpcoming": "Oma varaus alkamassa",
    "notInUse": "Ei käytössä",
    "ending": "Päättymässä",
    "starting": "Alkamassa"
  },
  "success": {
    "title": "Varaston varaus onnistui!",
    "description": "{{area}}, osoitteessa {{address}}.",
    "starts": "Varaus alkaa {{date}}"
  },
  "aria": {
    "availableIndicator": "Väri-indikaattori vapaalle yksikölle",
    "reservedIndicator": "Väri-indikaattori varatulle yksikölle",
    "mineIndicator": "Väri-indikaattori käyttäjän omalle varaukselle",
    "mineUpcomingIndicator": "Väri-indikaattori pian alkavalle omalle varaukselle"
  },
  "price": {
    "label": "Hinta",
    "perMonth": "{{amount}} / kk",
    "fromPerMonth": "alkaen {{amount}} / kk"
  },
  "tooltip": {
    "reservation": {
      "current": { "label": "Varaus" },
      "future": { "label": "Tuleva varaus" },
      "previous": { "label": "Edellinen varaus" }
    },
    "available": "Saatavilla",
    "openEnded": "(toistaiseksi)"
  },
  "reservation": {
    "form": {
      "description": "Varaa varasto",
      "submit": "Varaa"
    },
    "success": {
      "title": "Varaston varaus onnistui!",
      "description": "Varasto {{area}} varattu alkaen {{date}}",
      "starts": "Varaus alkaa"
    }
  },
  "effectiveFrom": "Muutos astuu voimaan",
  "error": {
    "contractMissing": "Sopimustieto puuttuu - varauksen tekeminen ei onnistu.",
    "reservationFailed": "Varauksen tekeminen epäonnistui. Yritä hetken kuluttua uudelleen.",
    "overlap": "Valittu aloituspäivä on ristiriidassa olemassa olevan varauksen kanssa. Valitse toinen päivä tai päätä nykyinen varaus.",
    "terminationFailed": "Varauksen päättäminen epäonnistui. Yritä hetken kuluttua uudelleen.",
    "reservationStartBeforeContractStart": "Varaus ei voi alkaa ennen sopimuksen alkamispäivää."
  },
  "terminate": {
    "form": {
      "description": "Irtisano varasto",
      "submit": "Irtisano"
    },
    "endDateLabel": "Muutos astuu voimaan",
    "futureReservationLabel": "Varaus astuu voimaan",
    "cta": "Peru varaus",
    "success": "Varaus peruutettu",
    "cancelledTitle": "Varaston varaus peruttu",
    "cancelledFrom": "Varastoyksikön {{area}} varaus on peruttu alkaen {{date}}",
    "reservationStartedOn": "Varauksen alkamispäivä {{date}}"
  },
  "modal": {
    "rulesLink": "Säännöt",
    "termsLink": "Varausehdot"
  },
  "extraService": {
    "myReservations": "Omat varastovaraukset",
    "startDate": "Alkamispäivä",
    "endDate": "Päättymispäivä",
    "openEnded": "Toistaiseksi voimassa",
    "active": "Aktiivinen",
    "ending": "Päättymässä pian",
    "pincode": {
      "code": "Pääsykoodi: {{pincode}}",
      "loading": "Ladataan pääsykoodia...",
      "loadError": "Pääsykoodin lataaminen epäonnistui"
    }
  }
}
